/**
 * product-lightbox.js
 * Fullscreen image lightbox for the product gallery.
 * Supports: keyboard nav (Arrows, Escape), touch swipe, backdrop-click close.
 */
(function () {
  /* Inject the variant-hidden CSS rule once — avoids a <style> tag in HTML */
  let style = document.createElement('style');
  style.textContent = '.product__media--variant-hidden { display: none !important; }';
  document.head.appendChild(style);

  document.querySelectorAll('.product__lightbox').forEach(function (dialog) {
    let sectionId      = dialog.id.replace('product-lightbox-', '');
    let mediaContainer = document.getElementById('product-lightbox-media-' + sectionId);
    let counter        = document.getElementById('product-lightbox-counter-' + sectionId);
    let currentIndex   = 0;

    function getItems() {
      return mediaContainer ? mediaContainer.querySelectorAll('.product__lightbox-item') : [];
    }

    function showItem(idx) {
      let items = getItems();
      let total = items.length;
      if (!total) return;
      currentIndex = ((idx % total) + total) % total;
      items.forEach(function (item, i) { item.classList.toggle('is-active', i === currentIndex); });
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + total;
    }

    function open(idx) {
      dialog.showModal();
      showItem(idx || 0);
      document.body.style.overflow = 'hidden';
    }

    function close() {
      dialog.close();
      document.body.style.overflow = '';
    }

    /* Open triggers from main gallery */
    let sectionEl = document.getElementById('product-section-' + sectionId);
    if (sectionEl) {
      sectionEl.addEventListener('click', function (e) {
        let btn = e.target.closest('[data-lightbox-open]');
        if (btn) { e.preventDefault(); open(parseInt(btn.dataset.lightboxOpen) || 0); }
      });
    }

    /* Close button */
    let closeBtn = dialog.querySelector('[data-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Backdrop click */
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

    /* Keyboard */
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape')     { close(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); showItem(currentIndex + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); showItem(currentIndex - 1); }
    });

    /* Nav buttons */
    let prevBtn = dialog.querySelector('[data-lightbox-prev]');
    let nextBtn = dialog.querySelector('[data-lightbox-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showItem(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showItem(currentIndex + 1); });

    /* Touch swipe */
    let touchX = 0;
    dialog.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    dialog.addEventListener('touchend',   function (e) {
      let dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) < 50) return;
      dx < 0 ? showItem(currentIndex + 1) : showItem(currentIndex - 1);
    });
  });
})();
